module.exports = __webpack_public_path__ + "static/img/notice-ban.ab85a1ee.jpg";